import { TPagination } from "@/types";
import { api } from ".";

type TPaginate = Pick<TPagination, "page" | "limit" | "search">;
const adminApi = {
  create: async (body: {}) => {
    return await api.post("admins", body);
  },

  update: async (body: {}) => {
    return await api.put("admins", body);
  },

  signin: async (body: {}) => {
    return await api.post("admins/sign-in", body);
  },

  signout: async () => {
    return await api.post("admins/sign-out");
  },

  me: async () => {
    return await api.get("admins/me");
  },

  changePassword: async (body: {}) => {
    return await api.post("admins/change-password", body);
  },

  updateMemberId: async (body: { id: number; memberId: string }) => {
    return await api.post("admins/update-memberId", body);
  },

  updateUserMemberId: async (body: {
    id: number;
    srikrungMemberId: string;
  }) => {
    return await api.post("admins/update-user-memberId", body);
  },

  approveUser: async (body: { id: number }) => {
    return await api.post("admins/approve-user", body);
  },

  disableUser: async (body: { id: number }) => {
    return await api.post("admins/disable-user", body);
  },

  getMemberById: async (id: number) => {
    return await api.get(`admins/members/${id}`);
  },

  getUserById: async (id: number) => {
    return await api.get(`admins/user/${id}`);
  },

  getContactStaffs: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `contactstaffs?page=${page}&limit=${limit}&search=${search}`
    );
  },

  getContactStaffById: async (id: number) => {
    return await api.get(`contactstaffs/${id}`);
  },

  updateContactStaffStatus: async (body: { id: number; status: number }) => {
    return await api.post("contactstaffs/update-status", body);
  },

  getInterestingRequest: async () => {
    return await api.get("interestingRequest");
  },

  getInterestingRequestById: async (id: number) => {
    return await api.get(`interestingRequest/${id}`);
  },

  updateInterestingRequestStatus: async (body: {
    id: number;
    status: number;
  }) => {
    return await api.post("interestingRequest/update-status", body);
  },

  updateDocStatus: async (body: { id: number; isPublished: boolean }) => {
    return await api.post("docs/admin/update-status", body);
  },

  updateBlogStatus: async (body: { id: number; isPublished: boolean }) => {
    return await api.post("blogs/update-status", body);
  },

  getBlogs: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `blogs/admin?page=${page}&limit=${limit}&search=${search}`
    );
  },

  createDoc: async (body: {}) => {
    return await api.post("docs/admin", body);
  },

  getDocs: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `docs/admin?page=${page}&limit=${limit}&search=${search}`
    );
  },

  updateDoc: async (body: {}) => {
    return await api.put("docs/admin", body);
  },

  getDoc: async (id: number) => {
    return await api.get(`docs/admin/${id}`);
  },

  getMembers: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `admins/members?page=${page}&limit=${limit}&search=${search}`
    );
  },

  getUsers: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `admins/users?page=${page}&limit=${limit}&search=${search}`
    );
  },

  getUserDownlinersById: async ({
    id,
    page,
    limit,
    search,
  }: TPaginate & { id: number }) => {
    return await api.get(
      `admins/user-downliners/${id}?page=${page}&limit=${limit}&search=${search}`
    );
  },

  getMemberDownlinersById: async ({
    id,
    page,
    limit,
    search,
  }: TPaginate & { id: number }) => {
    return await api.get(
      `admins/member-downliners/${id}?page=${page}&limit=${limit}&search=${search}`
    );
  },

  updateDocumentNo: async (data: {
    docs: Array<{ id: number; no: number }>;
  }) => {
    return await api.post("docs/admin/update-no", data);
  },
};

export default adminApi;
